module.exports = __webpack_public_path__ + "img/daytime_study2.969296aa.png";